(function () {
    /** @namespace Fotobook.commands */
    var self = Fotobook.commands = {

        EVENT_LOCK: 'lockCommands',

        /** Селектор для выборки панели инструментов */
        commandsSelector: '.commands',

        unlockCommands(){
            $(self.commandsSelector).removeClass('commands-locked');
        },

        lockCommands(){
            $(self.commandsSelector).addClass('commands-locked');
        },

        /**
         * Обработка кнопок в редакторе в верхнем правом углу
         *
         * @param event
         */
        processCommandButton(event) {
            const $this = $(event.currentTarget);
            const $html = $(':root');

            if ($html.hasClass('preview') &&
                $this.hasClass('nopreview') ||
                $this.hasClass('disabled') ||
                $(self.commandsSelector).hasClass('commands-locked')
            ) {
                return false;
            }

            const closePromise = Fotobook.store.dispatch('bottomPanel/close');
            // const closePromise = Fotobook.bottomPanel.close();

            const action = $this.attr('data-action');
            switch (action) {
                case 'preview-project':
                case 'editing-mode':
                    $(document).triggerHandler(Fotobook.events.COMMANDS_LOCK);
                    closePromise.then(() => {
                        self.togglePreview();
                        console.log('closed');
                    });
                    break;
                case 'autosave-project':
                    self.autosave.processCommand.call(this);
                    break;
                case 'save-project':
                    Fotobook.login.loginIfGuest().then(Fotobook.saveProject).catch(() => {});
                    break;
                case 'change-editor-mode':
                    Fotobook.changeEditMode($this.attr('data-id'));
                    break;
            }
        },

        /**
         * Переключение режима предпросмотра
         */
        togglePreview(state) {
            const currentMode = Fotobook.store.state.OnlineEditor.previewMode;
            if (state !== undefined && state === currentMode) {
                return;
            }
            Fotobook.store.commit('OnlineEditor/setPreviewMode', !currentMode);
            if (currentMode) {
                //переключаем в режим редактирования
                $(':root').removeClass('preview');
                location.hash = ''; // очащем хеш в урле
                $(document).triggerHandler(Fotobook.events.SWITCH_EDIT_MODE); // тригерим событе переключени в режим редактирвания
                $(document).triggerHandler(Fotobook.events.COMMANDS_UNLOCK);
            } else {
                //переключаем в режим предпросмотра
                $(':root').addClass('preview');
                location.hash = 'preview'; // add preview as hash param to make sure tha after page reloading preview mode will be kept
                $(document).triggerHandler(Fotobook.events.COMMANDS_UNLOCK);
                $(document).trigger(Fotobook.events.SWITCH_PREVIEW_MODE); // тригерим событие переключения в режим предпросмотра
            }

            // [FOT-6345] фикс: при выходе из превью на одностраничный режим вывода страницы считались неправильно
            if (currentMode && Fotobook.store.state.pagesPanel.singlePageMode) {
                Fotobook.pages.updatePageNumbers();
            }

            Fotobook.logEvent.info('PhotoBook.log.message.editor.preview');
            $(document).trigger('resize');
        },
    };

    $(document)
        .on('click', '.commands .commands-button[data-action]', self.processCommandButton)
        /* Создание превью во время аякс-запросов запрещено, так как в это время
         проект может полностью измениться */
        .on(Fotobook.events.AJAX_QUEUE_STARTED, () => {
            $('.preview-project').addClass('disabled');
        })
        .on(Fotobook.events.AJAX_QUEUE_FINISHED, () => {
            $('.preview-project').removeClass('disabled');
        })
        .on(Fotobook.events.COMMANDS_LOCK, self.lockCommands)
        .on(Fotobook.events.COMMANDS_UNLOCK, self.unlockCommands)
    ;

})();
